import { Box, Stack, Typography, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { ParameterDetailsSelector } from '../../../../../store/parameterDetails'

import { ColorScales } from './ColorScales'


export const ReadingScale = () => {
  const theme = useTheme()
  const selectedParameter = useSelector(ParameterDetailsSelector.selectSelectedParameter)
  const parameterDetails = useSelector(ParameterDetailsSelector.selectParameterDetailsState)
  const selectedParameterRanges = useSelector(ParameterDetailsSelector.makeSelectedParameterRanges)
  const selectedValue = selectedParameter?.value
  const values = parameterDetails?.values || []
  const colors = parameterDetails?.colors || []

  const getValueColor = () => {
    if (!values.length || !selectedValue) return theme.palette.red[700]
    const valueIndex = values.findIndex(val => val === selectedValue)
    if (valueIndex === -1) return theme.palette.red[800]
    return colors[valueIndex]
  }



  return (
    <Stack
      direction={{xs: "column", md:"row"}}
      justifyContent="space-between"
      gap={{xs: 5, md:0}} 
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: '#F3F6F880',
        pt: 3,
      }}
    >
      <Stack gap={2} direction="row" alignItems="center">
        <Box
          sx={{
            width: '4px',
            backgroundColor: getValueColor(),
            height: '100%',
          }}
        />
        <Stack>
          <Typography color={theme.palette.grey[600]} fontSize="1rem">
            Your reading
          </Typography>
          <Typography
            fontSize="2rem"
            fontWeight={theme.typography.fontWeightBold}
            color={theme.palette.grey[600]}
          >
            {Number(selectedParameter?.value).toFixed(1)}
          </Typography>
        </Stack>
      </Stack>

      <Box
        sx={{
          flexGrow:1, mx:1,
          width:{xs: '100%', md: 'auto'},
          alignSelf:{ md:"center", xs:"flex-start"}
        }}
         ><ColorScales
        colors={colors}
        values={values}
        selectedValue={selectedValue}
        selectedParameterRanges={selectedParameterRanges}
      /></Box>
    </Stack>
  )
}